export const CLAUDE_EXAM_DOMAINS = {
  agentic: {
    label: "Agentic Architecture & Orchestration",
    shortLabel: "Agentic Architecture",
    weight: 27,
  },
  tools: {
    label: "Tool Design & MCP Integration",
    shortLabel: "Tools & MCP",
    weight: 18,
  },
  code: {
    label: "Claude Code Configuration & Workflows",
    shortLabel: "Claude Code",
    weight: 20,
  },
  prompts: {
    label: "Prompt Engineering & Structured Output",
    shortLabel: "Prompts & Output",
    weight: 20,
  },
  reliability: {
    label: "Context Management & Reliability",
    shortLabel: "Context & Reliability",
    weight: 15,
  },
};
